import {
    Button,
    MenuItem,
} from '@chakra-ui/react';
import { ThemeTokens } from '@acp/core-ui';

import { ServiceShortName } from '@acp/shared';
import { ReportedFindingsMachineContext, ReportedFindingsWizardProvider } from './wizard/machine/context';
import { ReportedFindingModal } from './wizard/reported-finding-modal';

function ResolveButtonInner(
    {
        isMenuItem = false,
        compliancePropertyId,
        serviceShortName,
    }:
    { isMenuItem?: boolean;
        compliancePropertyId: number;
        serviceShortName: ServiceShortName | string;
    }
) {
    const machine = ReportedFindingsMachineContext.useActorRef();

    if (isMenuItem) {
        return (
            <MenuItem onClick={() => machine.send({ type: 'OPEN', compliancePropertyId, serviceShortName })}>
                Resolve
            </MenuItem>
        );
    }

    return (
        <Button
            borderRightWidth={1}
            borderRightColor="secondary.900"
            borderColor={ThemeTokens.Defaults.borderColor}
            color="muted.700"
            bgColor="white"
            onClick={() => machine.send({ type: 'OPEN', compliancePropertyId, serviceShortName })}
            colorScheme="charcoal"
            variant="outline"
            size="sm"
        >
            Resolve
        </Button>
    );
}

export function ReportedFindingResolveButton({
    compliancePropertyId,
    serviceShortName,
    isMenuItem = false,
}: {
    compliancePropertyId: number;
    serviceShortName: ServiceShortName | string;
    isMenuItem?: boolean;
}) {
    return (
        <ReportedFindingsWizardProvider
            compliancePropertyId={compliancePropertyId}
            serviceShortName={serviceShortName}
        >
            <ResolveButtonInner
                isMenuItem={isMenuItem}
                compliancePropertyId={compliancePropertyId}
                serviceShortName={serviceShortName}
            />
            <ReportedFindingModal compliancePropertyId={compliancePropertyId} />
        </ReportedFindingsWizardProvider>
    );
}
